export default function InfoEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
       {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2026-Fee-Schedule.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2026 Fee Schedule
          </a>
        </td>
        <td>01/10/2026</td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2025-Delaware-River-Boating-and-Recreation-Facilities-Feasibility-Study.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Delaware River Boating and Recreation Facilities Feasibility Study
          </a>
        </td>
        <td>10/22/2024</td>
      </tr>
      {/*End File*/}
     
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/employment/Borough-of-Morrisville-Employment-Application.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Non-Police Employment Application
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/rtk/PA-RTKRequestForm.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Right-To-Know Request Form
          </a>
        </td>
        <td>09/17/2024</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
